import { createFileRoute } from "@tanstack/react-router";
import { useWorkspace } from "../route";
import { WorkspaceSettingsPage } from "@/components/settings/WorkspaceSettingsPage";

function WorkspaceSettingsRoute() {
  const { workspace } = useWorkspace();
  return <WorkspaceSettingsPage workspace={workspace} />;
}

export const Route = createFileRoute("/$workspaceSlug/settings/workspace")({
  component: WorkspaceSettingsRoute,
});
